const AWARD_2021 = [
    {
        src: "award/2021/desktop/2021-1-desktop.webp",
        srcMobile: "award/2021/mobile/2021-1-mobile.webp",
        title: 'The Best Digital Media Gold Category in The Best Contact Center Indonesia 2021',
        awardBy: 'by Indonesia Contact Centre Association'
    },
    {
        src: "award/2021/desktop/2021-2-desktop.webp",
        srcMobile: "award/2021/mobile/2021-2-mobile.webp",
        title: 'Marketeer of The Year 2021',
        awardBy: 'by Markplus Inc.'
    },
    {
        src: "award/2021/desktop/2021-3-desktop.webp",
        srcMobile: "award/2021/mobile/2021-3-mobile.webp",
        title: "Impactful Digital Marketing Campaign of the Year for JAGOPACK in Marketeers Editor's Choice Award 2021",
        awardBy: 'by Marketeers'
    }
]

const AWARD_2022 = [
    {
        src: "award/2022/desktop/2022-1-desktop.webp",
        srcMobile: "award/2022/mobile/2022-1-mobile.webp",
        title: 'Marketeers OMNI Brands of The Year 2022 for JAGOPACK',
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2022/desktop/2022-2-desktop.webp",
        srcMobile: "award/2022/mobile/2022-2-mobile.webp",
        title: 'Forbes 30 Under 30 Year of 2022 for Farian Kirana, CEO Lion Parcel',
        awardBy: 'Forbes'
    },
    {
        src: "award/2022/desktop/2022-3-desktop.webp",
        srcMobile: "award/2022/mobile/2022-3-mobile.webp",
        title: "Prestige 40 Under 40 Year of 2022 for Farian Kirana, CEO Lion Parcel",
        awardBy: 'PRESTIGE'
    },
    {
        src: "award/2022/desktop/2022-4-desktop.webp",
        srcMobile: "award/2022/mobile/2022-4-mobile.webp",
        title: "EY Entrepreneur of The Year 2022 Finalist for Farian Kirana, CEO Lion Parcel",
        awardBy: 'EY'
    },
    {
        src: "award/2022/desktop/2022-5-desktop.webp",
        srcMobile: "award/2022/mobile/2022-5-mobile.webp",
        title: "Best of The Best Customer Service Team at Indonesia Customer Service Awards 2022 ",
        awardBy: 'by SWA Media Group and Business Digest'
    },
    {
        src: "award/2022/desktop/2022-6-desktop.webp",
        srcMobile: "award/2022/mobile/2022-6-mobile.webp",
        title: "Best of The Best Digital Marketing Team at Indonesia Digital Marketing Awards 2022 by SWA Media Group and Business Digest",
        awardBy: 'by SWA Media Group and Business Digest'
    },
    {
        src: "award/2022/desktop/2022-7-desktop.webp",
        srcMobile: "award/2022/mobile/2022-7-mobile.webp",
        title: "TOP Digital Implementation 2022 Level Stars 3",
        awardBy: 'by IT Works Magazine'
    },
    {
        src: "award/2022/desktop/2022-8-desktop.webp",
        srcMobile: "award/2022/mobile/2022-8-mobile.webp",
        title: "TOP Digital Implementation 2022 Level Stars 3",
        awardBy: 'by IT Works Magazine'
    }
]

const AWARD_2023 = [
    {
        src: "award/2023/desktop/2023-1-desktop.webp",
        srcMobile: "award/2023/mobile/2023-1-mobile.webp",
        title: '40 Under 40 Asia HR Leaders by Darwinbox for Angelina Siahaan, Head of People Lion Parcel',
        awardBy: 'Darwinbox'
    },
    {
        src: "award/2023/desktop/2023-2-desktop.webp",
        srcMobile: "award/2023/mobile/2023-2-mobile.webp",
        title: 'Fortune 40 Under 40 Year of 2023 for Farian Kirana, CEO Lion Parcel',
        awardBy: 'Fortune Indonesia'
    },
    {
        src: "award/2023/desktop/2023-3-desktop.webp",
        srcMobile: "award/2023/mobile/2023-3-mobile.webp",
        title: "Most Innovative Use of Cloud, Platforms and Ecosystems in FutureCFO Excellence Awards 2023",
        awardBy: 'FutureCFO'
    },
    {
        src: "award/2023/desktop/2023-4-desktop.webp",
        srcMobile: "award/2023/mobile/2023-4-mobile.webp",
        title: "Top 20 Franchisee Satisfaction 2023 Jasa Kurir Category",
        awardBy: 'by Majalah Franchise Indonesia'
    },
    {
        src: "award/2023/desktop/2023-5-desktop.webp",
        srcMobile: "award/2023/mobile/2023-5-mobile.webp",
        title: "Indonesia Branding Campaign of the Year 2023 Digital Marketing Category",
        awardBy: 'by Markplus, Inc.'
    },
    {
        src: "award/2023/desktop/2023-6-desktop.webp",
        srcMobile: "award/2023/mobile/2023-6-mobile.webp",
        title: "Indonesia Digital Customer Engagement Champion 2023 Services Industry Category",
        awardBy: 'by SWA Media Group'
    },
    {
        src: "award/2023/desktop/2023-7-desktop.webp",
        srcMobile: "award/2023/mobile/2023-7-mobile.webp",
        title: "Viral Social Media Campaign of the Year in Marketeer Editor's Choice Award 2023",
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2023/desktop/2023-8-desktop.webp",
        srcMobile: "award/2023/mobile/2023-8-mobile.webp",
        title: "The Best Digital Media Platinum Category in The Best Contact Center Indonesia 2023",
        awardBy: 'by Indonesia Contact Centre Association'
    },
    {
        src: "award/2023/desktop/2023-9-desktop.webp",
        srcMobile: "award/2023/mobile/2023-9-mobile.webp",
        title: "Logistics Platform of the Year in Indonesia Logistics Awards 2023",
        awardBy: 'by Supply Chain Indonesia'
    },
    {
        src: "award/2023/desktop/2023-10-desktop.webp",
        srcMobile: "award/2023/mobile/2023-10-mobile.webp",
        title: "Good in Indonesia Sales Team Champions 2023 by SWA Media Group",
        awardBy: 'by SWA Media Group'
    },
    {
        src: "award/2023/desktop/2023-11-desktop.webp",
        srcMobile: "award/2023/mobile/2023-11-mobile.webp",
        title: "Very Good in Indonesia Customer Experience Champions 2023",
        awardBy: 'by SWA Media Group'
    },
    {
        src: "award/2023/desktop/2023-12-desktop.webp",
        srcMobile: "award/2023/mobile/2023-12-mobile.webp",
        title: "Excellent in Indonesia Digital Marketing Champion 2023",
        awardBy: 'by SWA Media Group'
    },
    {
        src: "award/2023/desktop/2023-13-desktop.webp",
        srcMobile: "award/2023/mobile/2023-13-mobile.webp",
        title: "IT-Based Logistics Company of the Year in Bisnis Indonesia Logistics Awards 2023",
        awardBy: 'by Bisnis Indonesia'
    },
    {
        src: "award/2023/desktop/2023-14-desktop.webp",
        srcMobile: "award/2023/mobile/2023-14-mobile.webp",
        title: "Excellence in Influencer/KOLs Marketing, Marketing Excellence Awards 2023",
        awardBy: 'by Marketing Interactive'
    },
    {
        src: "award/2023/desktop/2023-15-desktop.webp",
        srcMobile: "award/2023/mobile/2023-15-mobile.webp",
        title: "Gold Predicate for Customer Experience in Contact Center Asia Pacific Awards 2023",
        awardBy: 'by Contact Center Association of Asia Pacific (CC-APAC)'
    }
]

const AWARD_2024 = [
    {
        src: "award/2024/desktop/2024-1-desktop.webp",
        srcMobile: "award/2024/mobile/2024-1-mobile.webp",
        title: 'Top Digital Innovation in Configuration, Product Offering, and Experience Innovation in Indonesia’s Top 20 Digital Innovation Awards 2024',
        awardBy: 'by The Iconomics'
    },
    {
        src: "award/2024/desktop/2024-2-desktop.webp",
        srcMobile: "award/2024/mobile/2024-2-mobile.webp",
        title: 'Operational Excellence Through Digital in Marketeers Omni Brands of the Year 2024',
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2024/desktop/2024-3-desktop.webp",
        srcMobile: "award/2024/mobile/2024-3-mobile.webp",
        title: "Creative Branding Campaign to Gen Z in Marketeers Youth Choice Award 2024",
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2024/desktop/2024-4-desktop.webp",
        srcMobile: "award/2024/mobile/2024-4-mobile.webp",
        title: "Gold Winner Public Relations Category in Indonesia Branding Campaign of The Year 2024",
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2024/desktop/2024-5-desktop.webp",
        srcMobile: "award/2024/mobile/2024-5-mobile.webp",
        title: "Waste Management of The Year in Sustainable Marketing Excellence 2024",
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2024/desktop/2024-6-desktop.webp",
        srcMobile: "award/2024/mobile/2024-6-mobile.webp",
        title: "Kategori Logistik Konvensional in 7 Most Popular Brand of The Year 2024",
        awardBy: 'by Jawa Pos'
    },
    {
        src: "award/2024/desktop/2024-7-desktop.webp",
        srcMobile: "award/2024/mobile/2024-7-mobile.webp",
        title: "New Service Logistics Campaign of The Year in Marketeers Editor's Choice Award 2024",
        awardBy: 'by Marketeers'
    },
    {
        src: "award/2024/desktop/2024-8-desktop.webp",
        srcMobile: "award/2024/mobile/2024-8-mobile.webp",
        title: "The Best Company Concerned QHSE (Logistic Industries) in Indonesia QHSE For Business Sustainability Awards 2024 (IQSA)",
        awardBy: 'by Business Asia Indonesia'
    },
    {
        src: "award/2024/desktop/2024-9-desktop.webp",
        srcMobile: "award/2024/mobile/2024-9-mobile.webp",
        title: "Stellar Workplace Recognition in Employee Commitment in Stellar Workplace Award 2024",
        awardBy: 'by Kontan'
    }
]

const AWARD_2025 = [
    {
        src: "award/2025/desktop/2025-1-desktop.webp",
        srcMobile: "award/2025/mobile/2025-1-mobile.webp",
        title: 'Indonesia Operational Excellence Champions 2025',
        awardBy: 'SWA and Business Digest'
    }
]

const INFO = [
    {
      titleDesktop: "<h2><span>Kirim paket</span> dari mana<br>saja dan ke mana saja</h2>",
      titleMobile: "<h2><span>Kirim paket</span> dari mana saja<br>dan ke mana saja</h2>",
      imgDesktop: "info-slider-1.webp",
      imgMobile: "info-slider-1-mobile.webp",
      descDesktop: "<h1>Lion Parcel, perusahaan jasa pengiriman yang<br>menjangkau <b>98% area di Indonesia dan 50+ negara<br>internasional.</b></h1>",
      descMobile: "<h1>Lion Parcel, perusahaan jasa pengiriman yang<br>menjangkau <b>98% area di Indonesia dan 50+<br>negara internasional.</b></h1>"

    },  
    {
      titleDesktop: "<p>Bebas <span>pilih layanan</span><br>yang sesuai kebutuhanmu</p>",
      titleMobile: "<p>Bebas <span>pilih layanan </span>yang<br>sesuai kebutuhanmu</p>",
      imgDesktop: "info-slider-2.webp",
      imgMobile: "info-slider-2-mobile.webp",
      descDesktop: "<div>Ekonomi atau Express, COD atau Non COD, pilih<br>saja, sesuaikan layanan dengan kebutuhanmu.</div>",
      descMobile: "<div>Ekonomi atau Express, COD atau Non COD,<br>pilih saja, sesuaikan layanan dengan<br>kebutuhanmu.</div>",

    },
    {
      titleDesktop: "<h3>Ongkir terbaik untuk <span>pengiriman</span><br>apapun sesuai kebutuhanmu</h3>",
      titleMobile: "<h3>Ongkir terbaik untuk<br><span>pengiriman </span>apapun sesuai<br>kebutuhanmu</h3>",
      imgDesktop: "info-slider-3.webp",
      imgMobile: "info-slider-3-mobile.webp",
      descDesktop: "<div>Besar maupun kecil, kami antar dengan<br>ongkir mulai Rp6.000.</div>",
      descMobile: "<div>Besar maupun kecil, kami antar dengan<br>ongkir mulai Rp6.000.</div>",
    },
    {
      titleDesktop: "<p>Paket dijamin <span>aman</span><br>dan <span>tepat waktu</span></p>",
      titleMobile: "<p>Paket dijamin <span>aman</span> dan<br><span>tepat waktu</span></p>",
      imgDesktop: "info-slider-4.webp",
      imgMobile: "info-slider-4-mobile.webp",
      descDesktop: "<div>Layanan terbaik dengan jaminan kepuasan<br>pelanggan.</div>",
      descMobile: "<div>Layanan terbaik dengan jaminan kepuasan<br>pelanggan.</div>",
    },
  ]

  const THREEBANNER = [
    {
      title: "Mau cuan jutaan? Jadi Agen Lion Parcel & raih keuntungannya!",
      imgDesktop: "ThreeBanner-1.webp",
      imgMobile: "ThreeBanner-1-mobile.webp",
      textBtn: "Daftar Agen",
      linkBtn: "/agen"
    },
    {
      title: "Kembangkan bisnismu dengan Lion Parcel – tarif kompetitif, aman, dan terpercaya!",
      imgDesktop: "ThreeBanner-2.webp",
      imgMobile: "ThreeBanner-2-mobile.webp",
      textBtn: "Ajukan kerja sama",
      linkBtn: "/korporasi"
    },  
    {
      title: "Siap untuk jadi #BeraniDiandelin? Yuk, gabung & berkembang bersama Lion Parcel!",
      imgDesktop: "ThreeBanner-3.webp",
      imgMobile: "ThreeBanner-3-mobile.webp",
      textBtn: "Lihat lowongan",
      linkBtn: "/career"
    },
  ]

  const CLIENT = [
    {
      alt: "Tokopedia",
      img: "tokopedia.svg"
    },
    {
      alt: "Blibli",
      img: "blibli.svg"
    },
    {
      alt: "Ikea",
      img: "ikea.svg"
    },
    {
      alt: "Samsung",
      img: "samsung.svg"
    },
    {
      alt: "BCA",
      img: "BCA.svg"
    },
    {
      alt: "sinarmas",
      img: "sinarmas.svg"
    },
    {
      alt: "avoskin",
      img: "avoskin.svg"
    }
  ]

module.exports = { AWARD_2021, AWARD_2022, AWARD_2023, AWARD_2024, AWARD_2025, INFO, THREEBANNER, CLIENT }
